module.exports = __webpack_public_path__ + "img/play_icon.9927b139.png";